import { cloneDeep, findIndex, isEmpty, isNil } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import { AddIcon } from 'tdesign-icons-react';
import { Button, Link, MessagePlugin, Popconfirm, Space, Table } from 'tdesign-react';
import Tip from '@/components/Tip';
import { renderOptions } from '@/utils/common';
import { variableOptionalOptions } from '@/utils/constant';
import VariableModal from '@/pages/Maintenance/Template/components/VariableModal';

export default function Variables({ value, onChange, label, tip, variableLevel, type }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [rowIndex, setRowIndex] = useState();

  const columns = [
    {
      colKey: 'variableType',
      title: '参数类型',
      width: 90,
      cell: renderOptions,
      options: variableOptionalOptions,
      fixed: 'left',
    },
    {
      colKey: 'key',
      title: '变量key',
      width: 200,
    },
    {
      colKey: 'keyName',
      title: '显示名称',
      width: 150,
    },
    {
      colKey: 'desc',
      title: '变量备注',
      width: 300,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row, rowIndex }) => (
        <Space>
          <Link
            theme='primary'
            onClick={() => {
              setCurrentRow(row);
              setRowIndex(rowIndex);
              setVisible(true);
            }}
            hover='color'
          >
            编辑
          </Link>
          <Popconfirm
            theme='danger'
            content='确定删除？'
            onConfirm={() => handleDel(row, rowIndex)}
          >
            <Link theme='danger' hover='color'>
              移除
            </Link>
          </Popconfirm>
        </Space>
      ),
      width: 120,
    },
  ];

  const handleDel = (row, rowIndex) => {
    const array = cloneDeep(value || []);
    array.splice(rowIndex, 1);
    onChange(array);
  };

  const handleClose = (val) => {
    const array = cloneDeep(value || []);

    if (val) {
      const { id, ...others } = val;
      const _val = {
        ...currentRow,
        ...others,
        varId: val.id,
      };
      if (findIndex(array, { key: _val.key }) > -1) {
        MessagePlugin.warning('变量已存在，请勿重复添加');
        return;
      }

      // 修改
      if (!isNil(rowIndex)) {
        array.splice(rowIndex, 1, _val);
        onChange(array);
      } else {
        onChange(array.concat(_val));
      }
    }
    setVisible(false);
    setCurrentRow(null);
    setRowIndex(null);
  };

  const addParam = () => {
    setVisible(true);
  };

  return (
    <Root>
      <Header>
        <Tip style={{ width: 150 }} content={tip}>
          {label}
        </Tip>
        <Button variant='outline' theme='primary' icon={<AddIcon />} onClick={addParam}>
          添加{label}
        </Button>
      </Header>
      {isEmpty(value) ? null : <Table maxHeight={400} data={value} columns={columns} />}
      <VariableModal
        scopeType={type}
        variableLevel={variableLevel}
        id={currentRow?.varId}
        visible={visible}
        handleClose={handleClose}
      />
    </Root>
  );
}

const Root = styled.div``;

const Header = styled.div`
  margin-bottom: 16px;
`;
